/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 创建视频点播订单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  videoId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.VideoOrderInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/order-detail-video/${videoId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
